var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1733 8.38658L12 13.5599L6.82664 8.38658C6.30664 7.86658 5.46664 7.86658 4.94664 8.38658C4.42664 8.90658 4.42664 9.74658 4.94664 10.2666L11.0666 16.3866C11.5866 16.9066 12.4266 16.9066 12.9466 16.3866L19.0666 10.2666C19.5866 9.74658 19.5866 8.90658 19.0666 8.38658C18.5466 7.87992 17.6933 7.86658 17.1733 8.38658Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.4f7498bc2d800f466a0fcc69b54bc013.svg";
export { ForwardRef as ReactComponent };